import { useEffect, useRef, useState } from 'react'
import styles from "../assets/styles/login.module.css"
import logo from "../assets/images/login/logo.svg"
import logo2 from "../assets/images/layout/sidebarlogo.png"
import girlImg from "../assets/images/login/groupimg.png"
import { verifyEmailTokenApi } from '../utils/api/services'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'

const VerifyEmail = () => {
    const [isVerified, setVerified] = useState<boolean>(false);
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    const hasRun = useRef(false);
    const navigate = useNavigate();
    const fetchVerifEmail = async (token: string) => {
        try {
            const result = await verifyEmailTokenApi(token);
            if (result?.success) {
                toast.success(result?.message || "Email verified successfully. You can now login.");
                setVerified(true);
            } else {
                setVerified(false);
                toast.error(result?.message || "Verification failed. Please try again.");
            }
        } catch (error) {
            setVerified(false);
            toast.error("Verification failed. Please try again.");
        }
    }

    useEffect(() => {

        if (!hasRun.current && token) {
            hasRun.current = true;
            fetchVerifEmail(token);
        }
    }, [token]);

    return (
        <div className={styles.loginMain}>
            <div className={`${styles.logo} ${styles.showOnlyOnMobile}`}>
                <img src={logo2} alt="logo" />
            </div>
            <div className="grid grid-cols-1 md:grid-cols-7 h-full">
                <section className={`col-span-4 ${styles.bannerSection}`}>
                    <div className={styles.logo}>
                        <img src={logo} alt="logo" />
                    </div>
                    <div className={styles.girlImg}>
                        <img src={girlImg} alt="girl image" />
                    </div>
                </section>
                <section className={`col-span-3 ${styles.formSection}`}>
                    <div className={styles.formBox}>
                        {
                            !token ? (
                                <div className={styles.loginHead}>
                                    <h3>No token provided</h3>
                                </div>
                            ) : isVerified ? (
                                <div className={styles.loginHead}>
                                    <h3>Email Verified Successfully!</h3>
                                    <p>You can now login.</p>
                                    <button
                                        type='submit'
                                        className='fillButton w-full mt-8'
                                        onClick={() => navigate('/login')}
                                    >
                                        LOGIN
                                    </button>
                                </div>
                            ) : (
                                <div className={styles.loginHead}>
                                    <h3>Email Verification Failed</h3>
                                </div>
                            )
                        }
                    </div>
                </section>
            </div>
        </div>
    )
}

export default VerifyEmail